module.exports = __webpack_public_path__ + "assets/img/page-background-sm-beae826d.jpg";